import $ from "jquery";
export default function contactFormLoadAjax() {
    $(".avu-single-msd-form").on('click', function(e) {
        e.preventDefault();
        let form = $(this).attr("data-single-form");
        let parentLink = $(this).closest('.avu-contact-categories-list-item-link');
        let parentFormValue = parentLink.attr('data-form');
        $('#form-name').val(form);
        $('#form-taxonomy').val(parentFormValue);
        $('#contact-form').submit();
    });
    if($('.avu-contact-template .avu-contact-form-outer-container').length > 0) {
        let formContainer = $('.avu-contact-template .avu-contact-form-outer-container');
        let offsetTop = formContainer.offset().top;
        if(window.innerWidth > 992) {
            offsetTop = offsetTop - 120;
        }
        if(window.innerWidth <= 992) {
            offsetTop = offsetTop - 60;
        }
        $('html, body').animate({
            scrollTop: offsetTop
        }, 0);
    }

    $(".avu-contact-categories-list-item-link").mouseenter(function() {
        if(window.innerWidth > 992) {
            $(this).find('.avu-form-selector').addClass("hide");
            $(this).find('.avu-contact-categories-list-item-purpose').addClass("show");
        }

    });
    $(".avu-contact-categories-list-item-link").mouseleave(function() {
        if(window.innerWidth > 992) {
            $(this).find('.avu-form-selector').removeClass("hide");
            $(this).find('.avu-contact-categories-list-item-purpose').removeClass("show");
        }
    });
    $("#avu-back-to-previous-page").click(function() {
        window.history.back();
    });






}







